export const Route = 'Organisation/RequestTracker/';
export const SearchOrganisationRequests = Route + "Search";
export const RequestEmployees = Route + 'RequestEmployees/';
export const LastestRequest = Route + 'LastestRequest/';
export const ValidationReview = Route + 'ValidationReview/';
export const TriggerDryRun = Route + 'TriggerDryRun/';

